import { Application, TextureStyle } from 'pixi.js';

// Set nearest-neighbor as the global default for ALL textures before any load.
// In PixiJS v8, TextureStyle.defaultOptions spreads individual magFilter/minFilter/mipmapFilter
// (all 'linear') AFTER applying scaleMode, so setting scaleMode alone is overridden.
// We must override the individual properties directly.
Object.assign(TextureStyle.defaultOptions, {
  magFilter: 'nearest',
  minFilter: 'nearest',
  mipmapFilter: 'nearest',
});

let appInstance: Application | null = null;

export async function initPixiApp(container: HTMLDivElement): Promise<Application> {
  if (appInstance) {
    appInstance.destroy(true);
    appInstance = null;
  }

  const app = new Application();

  await app.init({
    width: container.clientWidth,
    height: container.clientHeight,
    backgroundAlpha: 0, // transparent so CSS dot-grid shows through
    antialias: false,
    resolution: window.devicePixelRatio || 1,
    autoDensity: true,
    preference: 'webgl',
    preserveDrawingBuffer: true, // allows canvas.toDataURL for debugging
  });

  container.appendChild(app.canvas as HTMLCanvasElement);
  appInstance = app;

  // Debug: expose on window so we can inspect from browser console
  (window as unknown as Record<string, unknown>).__pixiApp = app;

  return app;
}

export function getPixiApp(): Application | null {
  return appInstance;
}

export function destroyPixiApp() {
  if (appInstance) {
    appInstance.destroy(true, { children: true, texture: true });
    appInstance = null;
  }
}
